export const updateTaskWithConnection = /* GraphQL */ `
  mutation UpdateTask(
    $input: UpdateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    updateTask(input: $input, condition: $condition) {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      taskMetadata {
        version
        product
        batch
        batchName
        versionProductBatch
        args {
          required
          default
          display
          order
          option
          type
          delimiter
          isMultiple
          isOutputFile
          isInputFile
          isSecret
          isResolvable
          sampleInput
        }
        requestBodyPropertyTemplates {
          requestBodyProperty
          template
        }
        createdAt
        updatedAt
      }
      title
      args {
        order
        option
        value
        replaceInFileName
      }
      includeInDownload
      createdAt
      updatedAt
    }
  }
`;

export const deleteTaskWithConnection = /* GraphQL */ `
  mutation DeleteTask(
    $input: DeleteTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    deleteTask(input: $input, condition: $condition) {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      taskMetadata {
        version
        product
        batch
        batchName
        versionProductBatch
        args {
          required
          default
          display
          order
          option
          type
          delimiter
          isMultiple
          isOutputFile
          isInputFile
          isSecret
          isResolvable
          sampleInput
        }
        requestBodyPropertyTemplates {
          requestBodyProperty
          template
        }
        createdAt
        updatedAt
      }
      title
      args {
        order
        option
        value
        replaceInFileName
      }
      includeInDownload
      createdAt
      updatedAt
    }
  }
`;

export const createTaskWithConnection = /* GraphQL */ `
  mutation CreateTask(
    $input: CreateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    createTask(input: $input, condition: $condition) {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      taskMetadata {
        version
        product
        batch
        batchName
        versionProductBatch
        args {
          required
          default
          display
          order
          option
          type
          delimiter
          isMultiple
          isOutputFile
          isInputFile
          isSecret
          isResolvable
          sampleInput
        }
        requestBodyPropertyTemplates {
          requestBodyProperty
          template
        }
        createdAt
        updatedAt
      }
      title
      args {
        order
        option
        value
        replaceInFileName
      }
      includeInDownload
      createdAt
      updatedAt
    }
  }
`;
